import { ActionButton } from '@fluentui/react';
import React, { useMemo } from 'react';

const FormActionButton = (props) => {

    const {
        disabled = false,
        id = undefined,
        onClick = (event) => console.log(event),
        primary = false,
        src,
        text = ""
    } = props;

    const styles = useMemo(
        () => {
            let styles = {
                button: {
                    flexContainer: {
                        justifyContent: "center",
                        gap: 11
                    },
                    icon: { height: 25 },
                    label: {
                        fontWeight: 700,
                        fontSize: 18,
                        lineHeight: "22px",
                        marginBottom: -5
                    },
                    root: {
                        background: primary
                            ? disabled
                                ? "#ECECEC"
                                : "red"
                            : "white",
                        border: "1px solid #ECECEC",
                        color: primary ? "white" : "black",
                        flexGrow: 1,
                        flexBasis: 1,
                        minHeight: 45,
                        selectors: {
                            ":hover > span": {
                                color: primary
                                    ? disabled
                                        ? "unset"
                                        : "white"
                                    : "red"
                            }
                        }
                    },
                },
                icon: {
                    root: { height: 25 },
                    image: { height: 25, fill: "red" }
                },
            };

            return styles;
        },
        [disabled, primary]
    );

    return <ActionButton
        disabled={disabled}
        iconProps={{
            imageProps: {
                src,
                styles: styles.icon
            }
        }}
        id={id}
        onClick={onClick}
        styles={styles.button}
    >
        {text}
    </ActionButton>;

};

export default FormActionButton;